import { Component, Inject, Input, OnInit } from '@angular/core';
import { HelpService } from '@app/common/services/help.service';
import { Restangular } from 'ngx-restangular';
import { saveAs } from 'file-saver';

@Component({
  selector: 'exports',
  templateUrl: './exports.component.html',
})
export class ExportsComponent implements OnInit {
  helpIds = HelpService.HELP_IDS;
  exportLoading: boolean;
  exportShpLoading: boolean;

  constructor(
    private restangular: Restangular,
  ) {
    this.onCreateExport = this.onCreateExport.bind(this);
    this.onCreateExportShp = this.onCreateExportShp.bind(this);
  }

  ngOnInit(): void {
  }

  onCreateExport(): Promise<any> {
    this.exportLoading=true;
    return this.restangular.all('/diagnostics/export-xlsx')
       .withHttpConfig({ responseType: 'blob' })
       .customPOST()
       .toPromise()
       .then((data) => {
         const blob = new Blob([data], {type: 'text/csv;charset=utf-8'});
         saveAs(blob, 'Useky_dle_TP87.xlsx');
         this.exportLoading = false;
       }, () => {
         this.exportLoading = false;
       });
  }

  onCreateExportShp(): Promise<any> {
    this.exportShpLoading=true;
    return this.restangular.all('/diagnostics/export-shp')
       .withHttpConfig({ responseType: 'blob' })
       .customPOST()
       .toPromise()
       .then((data) => {
         const blob = new Blob([data], {type: 'text/csv;charset=utf-8'});
         saveAs(blob, 'exportSHP.zip');
         this.exportShpLoading = false;
       }, () => {
         this.exportShpLoading = false;
       });
  }
}
